import React from 'react';
import { useHistory } from 'react-router-dom';
import Header from '../components/Header';
const Slot = () => {
    let history =useHistory();
    const proceed =()=>{
        history.push("/user/cart")
    }
    return (
        <div>
            <Header />
            <h6>*You can go back to cart and purcase more after confirming slot by at least one product payment </h6>
            <div className="container">
                <h4>Choose your time slot</h4>
                <br/><h1 className="text-center display-1">PVS MANGO BAKERS</h1>
                <div>
                    <ul className="list-group" style={{backgroundColor: "#e8ffff"}}>
                        <div>
                            <div className="alert alert-warning" role="alert">Sorry...This slots are unavailable now.....</div>
                        </div>
                        <div>
                            <div className="alert alert-warning" role="alert">Sorry...This slots are unavailable now.....</div>
                        </div>
                        <div>
                            <div className="alert alert-warning" role="alert">Sorry...This slots are unavailable now.....</div>
                        </div>
                        <div>
                            <div className="alert alert-warning" role="alert">Sorry...This slots are unavailable now.....</div>
                        </div>
                        <div>
                            <li className="list-group-item d-flex justify-content-between align-items-center">
                                <label htmlFor="option">12:00:00 AM - 1:00:00 PM</label>
                                <input type="radio" id="option" name="selector"/>
                                <div className="check"><div className="inside"></div></div>
                                <span className="badge badge-primary badge-pill">15 slot left</span>
                            </li>
                        </div>
                        <div>
                            <li className="list-group-item d-flex justify-content-between align-items-center">
                                <label htmlFor="option">1:00:00 PM - 2:00:00 PM</label>
                                <input type="radio" id="option" name="selector"/>
                                <div className="check"><div className="inside"></div></div>
                                <span className="badge badge-primary badge-pill">15 slot left</span>
                            </li>
                        </div>
                        <div>
                            <li className="list-group-item d-flex justify-content-between align-items-center">
                                <label htmlFor="option">2:00:00 PM - 3:00:00 PM</label>
                                <input type="radio" id="option" name="selector"/>
                                <div className="check"><div className="inside"></div></div>
                                <span className="badge badge-primary badge-pill">13 slot left</span>
                            </li>
                        </div>
                        <div>
                            <li className="list-group-item d-flex justify-content-between align-items-center">
                                <label htmlFor="option">3:00:00 PM - 4:00:00 PM</label>
                                <input type="radio" id="option" name="selector"/>
                                <div className="check"><div className="inside"></div></div>
                                <span className="badge badge-primary badge-pill">8 slot left</span>
                            </li>
                        </div>
                        <div>
                            <li className="list-group-item d-flex justify-content-between align-items-center">
                                <label htmlFor="option">4:00:00 PM - 5:00:00 PM</label>
                                <input type="radio" id="option" name="selector"/>
                                <div className="check"><div className="inside"></div></div>
                                <span className="badge badge-primary badge-pill">12 slot left</span>
                            </li>
                        </div>
                        <div>
                            <li className="list-group-item d-flex justify-content-between align-items-center">
                                <label htmlFor="option">5:00:00 PM - 6:00:00 PM</label>
                                <input type="radio" id="option" name="selector"/>
                                <div className="check"><div className="inside"></div></div>
                                <span className="badge badge-primary badge-pill">15 slot left</span>
                            </li>
                        </div>
                    </ul>
                    <button type="button" className="btn btn-success btn-lg btn-block" onClick={proceed} id="proceed">Proceed</button>
                </div>
            </div>
        </div>
    );
};
export default Slot;